import { render, staticRenderFns } from "./InsideHome.vue?vue&type=template&id=5d7d00b8&"
import script from "./InsideHome.vue?vue&type=script&lang=js&"
export * from "./InsideHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\LRGithub\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d7d00b8')) {
      api.createRecord('5d7d00b8', component.options)
    } else {
      api.reload('5d7d00b8', component.options)
    }
    module.hot.accept("./InsideHome.vue?vue&type=template&id=5d7d00b8&", function () {
      api.rerender('5d7d00b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/inside-home/InsideHome.vue"
export default component.exports